export enum LOCAL_STORAGE_KEYS {
  AccessToken = 'access_token',
  RefreshToken = 'refresh_token',
  IdToken = 'id_token',
}

export const getAuthToken = (tokenType: LOCAL_STORAGE_KEYS): string | null => {
  return localStorage.getItem(tokenType);
};
